/**
 * 个人素材顶部工具条的滚动修正指令 
 */
"use strict";
angular.module("scrollFixLocalDirModule", []).
directive("scrollFixLocal", ["globleParamsSet", "$timeout", function(globleParamsSet, $timeout) {
    return {
        restrict: "A",
        scope: false,
        link: function(scope, $elem, $attrs) {
            var $parent = $elem.parent();
            initStatus();
            /**
             * [initStatus description] 初始化状态
             * @return {[type]} [description]
             */
            function initStatus() {
                //globleParamsSet.domObserver($(".body_right_iWo")[0], { attribute: true, attributeOldValue: true }, function(e) {
                window.addEventListener("scroll", myScroll);
                $parent.bind("scroll", myScroll);

                function myScroll() {
                    var fixTop = isNaN($attrs["fixTop"]) ? 0 : Number($attrs["fixTop"]);
                    var parentTop = $parent.offset().top; //父元素的真实顶部距离
                    var parentHeight = $parent[0].offsetHeight;
                    var parentShowHeight = parentHeight + parentTop - $("html")[0].scrollTop;
                    if (parentShowHeight - parentHeight < 75) {
                        if ($("html")[0].scrollTop === 0) {
                            $elem.removeAttr("style");
                        } else {     
                            $parent.height(window.innerHeight - $(".header").height() - $(".footer").height());
                            $elem.offset({ top: $("html")[0].scrollTop + 60 + fixTop });
                        }
                    } else {
                        $elem.removeAttr("style");
                        //$elem.offset({ top: parentTop });
                    }
                }
                scope.$on("$destroy", function() {
                    window.removeEventListener("scroll", myScroll);
                });
                //});
            }
        }
    };
}]);